module.exports = __webpack_public_path__ + "img/bomb.871bdc6d.gif";